import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import _ from 'underscore';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import auth from '../../../../auth/Auth';
import { formatarNumeroFamiliar } from '../../../../common/formatadores';
import AjudaRapida from '../../../../components/AjudaRapida/AjudaRapida';
import Card from '../../../../components/Card/Card';
import LoadingGlobal from '../../../../components/LoadingGlobal/LoadingGlobal';
import MainContainer from '../../../../components/MainContainer/MainContainer';
import { TipoPerfil } from '../../../../model/TipoPerfil';
import { limparDadosFamilia } from '../../../ConsultaSimples/consultaSimplesSlice';
import {
  getPerfis,
  perfilUpdated,
  selecionarNumeroFamiliar,
  selecionarPerfil,
  selecionarTipoPerfil,
  selectBuscandoPerfis,
  selectNumeroFamiliar,
  selectPerfilCompleto,
  selectPerfis,
  selectSituacaoCadastroFamilia,
  selectTipoPerfil,
} from '../../perfilSlice';
import styles from '../SelecionarPerfil.module.css';
import { selectLoadingCount } from '../../../../globalSlice';
import Skeleton from 'react-loading-skeleton';
import { setMostrarModalPendencias } from '../../../ConsultaPendencias/consultaPendenciasSlice';
import { obterNomeDoPerfil } from '../../../../common/perfilUtils';


const SelecionarPerfil: React.FC<any> = (props) => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const tipoPerfil = useAppSelector(selectTipoPerfil);
  const numeroFamiliar = useAppSelector(selectNumeroFamiliar);
  const perfis = useAppSelector(selectPerfis);
  const [trocandoPerfil, setTrocandoPerfil] = useState(props.location?.state?.trocandoPerfil);
  const [trocandoFamilia, setTrocandoFamilia] = useState(props.location?.state?.trocandoFamilia);

  const buscandoPerfis = useAppSelector(selectBuscandoPerfis);

  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);

  const perfil = useAppSelector(selectPerfilCompleto);

  const loadingCount = useAppSelector(selectLoadingCount);


  const tiposPerfil = useCallback(() => {
    if (!perfis) {
      return [];
    }
    return Object.keys(
      _.groupBy(perfis, function (perfil) {
        return perfil.tipoPerfil.codigo;
      })
    );
  }, [perfis]);

  const familias = (codigoTipoPerfil: any) => {
    return _.filter(perfis, (perfil) => {
      return perfil.tipoPerfil.codigo === codigoTipoPerfil;
    });
  };

  useEffect(() => {
    if (perfis) {
      if (perfis.length === 1) {
        // Se o usuário possuir apenas 1 perfil, redirecionar para o home com perfil e família selecionados
        dispatch(selecionarTipoPerfil(perfis[0].tipoPerfil.codigo));
        dispatch(selecionarNumeroFamiliar(perfis[0].numeroFamiliar));
        dispatch(selecionarPerfil(perfis[0]));
        history.push("/home");
      } else if (perfis.length > 1 && tiposPerfil().length === 1) {
        // Se o usuário possuir mais de 1 perfil, mas com umn tipo de perfil (exemplo: RL com mais de 1 família)
        // selecionar o tipo de perfil e exibir o componente para escolher a família
        dispatch(selecionarTipoPerfil(perfis[0].tipoPerfil.codigo));
        setTrocandoPerfil(false);
        setTrocandoFamilia(true);
      }

    } else {
     // Caso o perfil esteja vazio, direcionar para o getPerfis para obter os perfis
      if (auth.getUser()) {
        dispatch(getPerfis(auth.getUser()));
      }
    }
  }, [dispatch, perfis, perfil, tiposPerfil, auth.getUser(), trocandoFamilia]);

  const escolherTipoPerfil = async(perfil: string | number) => {
    const codigoTipoPerfil = typeof perfil === 'string' ? parseInt(perfil) : perfil;
    await dispatch(selecionarTipoPerfil(codigoTipoPerfil));
    auth.setTipoPerfilSelecionado(codigoTipoPerfil);

    await dispatch(setMostrarModalPendencias(true));

    const perfilFiltrado = perfis.filter((p) => p.tipoPerfil.codigo === codigoTipoPerfil);
    auth.setPerfilSelecionado(perfilFiltrado[0]);

    const familiasPorPerfil = familias(codigoTipoPerfil);

    if (familiasPorPerfil.length === 1) {
      escolherFamilia(codigoTipoPerfil, familiasPorPerfil[0].numeroFamiliar);
    } else if (trocandoPerfil) {
      setTrocandoFamilia(true);
      setTrocandoPerfil(false);
    }
  };

  const escolherFamilia = async(codigoTipoPerfil: any, codigoFamiliar: number) => {
    dispatch(selecionarNumeroFamiliar(codigoFamiliar));
    auth.setFamiliaSelecionada(codigoFamiliar);

    await dispatch(setMostrarModalPendencias(true));

    const filtroPerfil = _.filter(perfis, perfil => {
      return perfil.tipoPerfil.codigo === codigoTipoPerfil && perfil.numeroFamiliar === codigoFamiliar;
    });

    if (filtroPerfil.length === 1) {
      dispatch(selecionarPerfil(filtroPerfil[0]));
    }

    if (trocandoFamilia || trocandoPerfil) {
      dispatch(limparDadosFamilia());
      dispatch(perfilUpdated());
      history.push('/home');
    }
  };

  const getNomePerfil = () => {
    switch (tipoPerfil) {
      case TipoPerfil.RESPONSAVEL_FAMILIAR:
        return 'Responsável Familiar';
      case TipoPerfil.REPRESENTANTE_LEGAL:
        return 'Representante Legal';
      case TipoPerfil.INTEGRANTE_FAMILIAR:
        return 'Integrante Familiar';
    }
  };

  const deveExibirSelecionePerfil = () => {
    const resultado = tiposPerfil().length > 1 && (!tipoPerfil || trocandoPerfil);
    return resultado;
  };

  const deveExibirSelecioneFamilia = () => {
    const resultado = tipoPerfil && (!numeroFamiliar || trocandoFamilia);
    return resultado;
  };

  const selecionePerfil = (
    <>
      <Card>
        <div className={styles.title}>Selecione o perfil</div>
        <div className={styles.msgWrapper}>
          <i className={`fas fa-info-circle ${styles.icon}`} />
          <div className="flex-column">
            <span className={styles.msgTitle}>
              Você possui {tiposPerfil().length} perfis no Cadastro Único.
            </span>
            <span>Por favor, escolha um para continuar.</span>
          </div>
        </div>
        <div className={styles.listaBotoes}>
          {tiposPerfil().map((perfil, index) => (
            <div
              className={styles.botaoPerfil}
              key={index}
              onClick={() => escolherTipoPerfil(perfil)}
            >
              {perfil === TipoPerfil.RESPONSAVEL_FAMILIAR.toString() && (
                <>
                  <i className={`fas fa-id-card-alt ${styles.icon}`} />
                  <span className={styles.text}>Responsável Familiar</span>
                </>
              )}
              {perfil === TipoPerfil.REPRESENTANTE_LEGAL.toString() && (
                <>
                  <i className={`fas fa-user-tie ${styles.icon}`} />
                  <span className={styles.text}>Representante Legal</span>
                </>
              )}
              {perfil === TipoPerfil.INTEGRANTE_FAMILIAR.toString() && (
                <>
                  <i className={`fas fa-user ${styles.icon}`} />
                  <span className={styles.text}>Integrante Familiar</span>
                </>
              )}
            </div>
          ))}
        </div>
      </Card>
      <AjudaRapida>
        <div className={styles.textoAjudaRapida}>
          No Cadastro Único, você está vinculado a mais de uma família, sendo que em uma delas você
          é o(a) Responsável Familiar (RF) ou um dos integrantes da família e em outra você é o(a)
          Representante Legal (RL). Por estar vinculado a mais de uma família, você precisará
          escolher com qual perfil deseja ingressar:
          <ul>
            <li>
              o(a) Responsável Familiar (RF) é a pessoa da família que prestou as informações de
              todos os integrantes da família para o entrevistador do Cadastro Único.
            </li>
            <li>
              o(a) Representante Legal (RL) é o tutor, curador ou guardião responsável por pessoa(s)
              que não possuem pessoa que possa ser um(a) Responsável Familiar (RF) na família, sejam
              elas crianças ou adolescentes menores de 16 anos ou adultos incapazes.
            </li>
            <li>
              Integrante familiar é a pessoa cadastrada pelo(a) Responsável Familiar (RF) ou pelo(a)
              Representante Legal (RL).
            </li>
          </ul>
          Você precisa definir como você gostaria de seguir consultando os dados no aplicativo. A
          qualquer momento você poderá mudar este perfil por meio do ícone <i className={`fas fa-exchange-alt ${styles.trocarIcon}`}/> dentro do
          aplicativo
        </div>
      </AjudaRapida>
    </>
  );

  const selecioneFamilia = (
    <>
      <Card>
        <div className={styles.title}>Selecione a família</div>
        <div className={styles.msgWrapper}>
          <i className={`fas fa-info-circle ${styles.icon}`} />
          <div className="flex-column">
            <span>
              <strong>Você é {getNomePerfil()} de mais de uma família.</strong> Por favor, escolha
              uma para continuar.
            </span>
          </div>
        </div>
        <div className={styles.listaBotoes}>
          {familias(tipoPerfil).map((familia, index) => (
            <div
              className={styles.botaoFamilia}
              key={index}
              onClick={() => escolherFamilia(tipoPerfil, familia.numeroFamiliar)}
            >
              <i className={`fas fa-users ${styles.icon}`} />
              <div className="flex-column">
                <span className={styles.codigoFamilia}>
                  Código familiar <strong>{formatarNumeroFamiliar(familia.numeroFamiliar)}</strong>
                </span>
                <span className={styles.integrantesFamilia}>
                  {familia.integrantesFamilia[0].nomePessoa}
                  {familia.integrantesFamilia.length > 1 && (
                    <>
                     &nbsp;e mais {familia.quantidadeIntegrantes - 1} integrante
                      {familia.quantidadeIntegrantes > 2 && 's'}
                    </>
                  )}
                </span>
                {familia.municipio && familia.uf && (
                  <div className={styles.enderecoFamilia}>
                    <i className={`fas fa-map-marker-alt ${styles.iconEndereco}`} />
                    {familia.municipio}/{familia.uf}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </Card>
      <AjudaRapida>
        <div className={styles.textoAjudaRapida}>
          Como você é o(a) Representante Legal (RL) de mais de uma família, você precisa definir
          qual família deseja consultar no aplicativo. A qualquer momento você poderá mudar a
          família escolhida por meio do ícone{' '}
          <i className={`fas fa-exchange-alt ${styles.trocarIcon}`} /> dentro do aplicativo.
        </div>
      </AjudaRapida>
    </>
  );

  if (buscandoPerfis) {
    return <LoadingGlobal/>;
  }

  return (
    <MainContainer
      userNav={!!perfil}
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      barraAuxiliar={true}
      padraoInicial={!perfil}
      navFixed
      navHideArrow={!!perfil ? false : true}>
      <div className={styles.container}>
        {loadingCount ? (
        <>
          <Card>
            <Skeleton count={4} />
            <br />
          </Card>
          <Card>
            <Skeleton count={4} />
          </Card>
        </>) : (
          <>
            {deveExibirSelecionePerfil() && selecionePerfil}
            {deveExibirSelecioneFamilia() && selecioneFamilia}
          </>)
        }
      </div>
    </MainContainer>
  );
};

export default SelecionarPerfil;
